<template>
  <div :class="[modalUUID]" class="modal">
    <v-card max-width="600px">
      <v-card-title :class="[type, color]" class="text-h5">
        <v-icon :class="[color]" class="mr-2">{{ icon }}</v-icon>
        <span>{{ title }}</span>
      </v-card-title>

      <v-card-text class="pt-5">
        <span v-html="globalBaseModalMessage.text" class="text" />
      </v-card-text>

      <v-card-actions class="pt-0 pb-4 px-4">
        <v-checkbox
          :value="checkbox"
          :class="[checkboxUUID]"
          :label="$t('message.baseModalMessage.label')"
          class="py-0 my-0"
          hide-details
        />
        <v-spacer />
        <v-btn :class="[btnUUID]" text>
          {{ $t('message.baseModalMessage.btn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid'

import Storage from '@/utils/Storage'

export default {
  name: 'BaseModalMessage',

  data: () => ({
    uuid: uuidv4(),
    checkbox: false,
    checkboxStorageKey: 'globalBaseModalMessageCheckbox',
    types: {
      primary: {
        icon: 'mdi-alert-circle',
      },
      warning: {
        icon: 'mdi-alert',
      },
      error: {
        icon: 'mdi-alert-octagon',
      },
      success: {
        icon: 'mdi-checkbox-marked-circle',
      },
    },
  }),

  computed: {
    ...mapState('user', ['globalBaseModalMessage']),

    type() {
      return this.globalBaseModalMessage.type
    },

    key() {
      return this.globalBaseModalMessage.key
    },

    title() {
      return this.$t(`message.baseModalMessage.titles.${this.type}`)
    },

    icon() {
      return this.types[this.type].icon
    },

    color() {
      const lightMode = ['warning']
      if (lightMode.includes(this.type)) return 'black--text'
      return 'white--text'

      // return `${this.type}--text`
    },

    modalUUID() {
      return `js-modal-${this.uuid}`
    },

    btnUUID() {
      return `js-btn-${this.uuid}`
    },

    checkboxUUID() {
      return `js-checkbox-${this.uuid}`
    },
  },

  created() {
    window.addEventListener('click', this.stop, true)
    window.addEventListener('keydown', this.escape)
  },

  destroyed() {
    window.removeEventListener('click', this.stop, true)
    window.removeEventListener('keydown', this.escape)
  },

  mounted() {
    const messageStorage = Storage.getItem(this.checkboxStorageKey) ?? {}
    this.checkbox = messageStorage[this.key] ?? false
  },

  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_BASE_MODAL_MESSAGE']),

    stop(event) {
      const { target } = event

      const modal = target.classList.contains(this.modalUUID)
      const btn = target.closest(`.${this.btnUUID}`)
      const checkbox = target.closest(`.${this.checkboxUUID}`)

      event.stopImmediatePropagation()
      event.stopPropagation()
      event.preventDefault()

      if (checkbox) this.handleCheckbox()
      if (modal || btn) this.close()
    },

    escape(event) {
      if (event.key === 'Escape') this.close()
    },

    close() {
      this.UPDATE_GLOBAL_BASE_MODAL_MESSAGE({
        open: false,
        type: 'primary',
        key: '',
        text: '',
      })
    },

    handleCheckbox() {
      const messageStorage = Storage.getItem(this.checkboxStorageKey) ?? {}

      this.checkbox = !this.checkbox
      messageStorage[this.key] = this.checkbox

      Storage.setItem(this.checkboxStorageKey, messageStorage)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, 0.35);

  align-items: center;
  justify-content: center;
}

.text {
  &::v-deep {
    p {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
